{
  "status": {
    "provisioning": "Provisioning",
    "active": "Active",
    "suspended": "Suspended",
    "cancelled": "Cancelled"
  },
  "checkingSession": "Checking session…",
  "login": {
    "error": "Unable to sign in.",
    "title": "Platform dashboard",
    "subtitle": "Access restricted to the Xtreed team.",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in"
  },
  "panel": {
    "errors": {
      "generic": "Unable to complete."
    },
    "toast": {
      "created": "Members area created at {{url}}",
      "statusUpdated": "Status updated."
    },
    "badge": "Platform",
    "logout": "Log out",
    "title": "Clients",
    "count_one": "{{count}} members area",
    "count_zero": "{{count}} members areas",
    "count_other": "{{count}} members areas",
    "newClient": "New client",
    "loading": "Loading…",
    "features": "Features",
    "reactivate": "Reactivate",
    "suspend": "Suspend"
  },
  "form": {
    "name": "Name",
    "namePlaceholder": "John's School",
    "slug": "Identifier",
    "slugPlaceholder": "johns-school",
    "adminEmail": "Admin email",
    "adminEmailPlaceholder": "admin@school.com",
    "adminName": "Admin name",
    "adminNamePlaceholder": "John Smith",
    "adminPassword": "Initial password",
    "submit": "Create"
  },
  "features": {
    "community": "Community",
    "certificates": "Certificates",
    "gamification": "Gamification",
    "assistant": "AI assistant",
    "toast": {
      "updated": "Plan updated.",
      "error": "Unable to save."
    },
    "loading": "Loading features…",
    "includedInPlan": "Included in plan",
    "enabledByClient": "· enabled by the client",
    "disabledByClient": "· disabled by the client"
  }
}
